const base_links = [
    {
        href: '/daily-horoscope',
        label: 'Daily Horoscope',
        html: 'Daily<br />Horoscope',
        slug: 'horoscope',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/horoscope.svg',
    },
    {
        href: '/daily-love-horoscope',
        label: 'Daily Love Horoscope',
        html: 'Daily Love<br />Horoscope',
        slug: 'love',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/love.svg',
    },
    {
        href: '/daily-tarot-card',
        label: 'Tarot Card of the Day',
        html: 'Tarot Card<br />of the Day',
        slug: 'tarot',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg',
    },
    {
        href: '/daily-number',
        label: 'Number of the Day',
        html: 'Number<br />of the Day',
        slug: 'number',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg',
    },
    {
        href: {
            nonmobile: '/daily-psychic-tip',
            mobile: '/daily-psychic-advisors',
        },
        label: 'Psychic Tip of the Day',
        html: 'Psychic Tip<br />of the Day',
        slug: 'psychic',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/psychic.svg',
    },
    {
        href: '/daily-hexagram',
        label: 'Hexagram of the Day',
        html: 'Hexagram<br />of the Day',
        slug: 'hexagram',
        img: 'https://gfx.tarot.com/images/daily-pages/daily-icons/hexagram.svg',
    },
];

let links = base_links;

if (document.location.href.match(/vip/)) {
    links = [
        {
            href: '/transits',
            label: 'Daily Transits',
            html: 'Daily<br />Transits',
            slug: 'transits',
            img: 'https://gfx.tarot.com/images/site/membership/icon.svg',
        },
        base_links[0],
        base_links[1],
        base_links[2],
        base_links[3],
        base_links[5],
        base_links[4],
    ];
}

export const initial = links;
